import Moment from 'moment';

export const getPriceWarning = (sku, expireOn) => {
  // Temporary price increase warnings
  const CUR_DATE = Moment();
  const WARNING_SKUS = ['170299', '170297'];
  const IS_WARNING_SKU = WARNING_SKUS.includes(sku);
  const WARNING_START = Moment('January 1, 2022 00:00:01');
  const WARNING_END = Moment('January 31, 2022 23:59:59');
  const WARNING_ACTIVE = (CUR_DATE >= WARNING_START && CUR_DATE <= WARNING_END);
  const PRICE_WARNING = (IS_WARNING_SKU && WARNING_ACTIVE);
  const MESSAGE = '*The monthly price for Simplifi will increase to $5.99 on February 1. You will be charged the new price when you renew in February.';

  const WARNING_SKUS_ANNUAL = ['170298', '170333', '170296', '170325', '170368', '170382', '170386', '170390', '170403'];
  const IS_ANN_WARNING_SKU = WARNING_SKUS_ANNUAL.includes(sku);
  const ANN_WARNING_START = Moment('March 29, 2022 00:00:01');
  const ANN_WARNING_END = Moment('May 31, 2022 23:59:59');
  const ANN_WARNING_ACTIVE = (CUR_DATE >= ANN_WARNING_START && CUR_DATE <= ANN_WARNING_END);
  const EXPIRED_CHECK = expiredDatePast(expireOn);
  const ANN_PRICE_WARNING = (IS_ANN_WARNING_SKU && ANN_WARNING_ACTIVE && (EXPIRED_CHECK <= 0));
  const ANN_MESSAGE = '*The annual price for Simplifi will increase to $47.99 on June 1 2022. You will be charged the new price at your next renewal.';

  return {
    PRICE_WARNING: PRICE_WARNING,
    PRICE_WARNING_MSG: MESSAGE,
    ANN_PRICE_WARNING: ANN_PRICE_WARNING,
    ANN_PRICE_WARNING_MSG: ANN_MESSAGE
  };
};

const expiredDatePast = expireOn => {
  const diff = Moment('May 31 2022').diff(Moment(expireOn), 'days');
  return diff;
};

// Purpose for the specific dates in here listed in:
// https://quickenteam.atlassian.net/browse/QMNT-5922

// const SKU_NOTICES_MAP = [
//   {
//     name: "Monthly Simplifi Price Increase",
//     skus: ['170299', '170297'],
//     noticeStartDate: 'January 1, 2022',
//     noticeEndDate: 'January 31, 2022',
//     conditions: []
//   },
// ]